import  { useState, useEffect, useRef } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import styles from '../css/EarnPage.module.css';
import squirrelImage from '../public/sq.png';
import Navbar from '../components/NavBar.js';
import Footer from '../components/Footer.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ViewCount from '../components/ViewCount.js';
import Withdraw from '../components/Withdraw'; 
import Head from 'next/head';
import Image from 'next/image';
  
import useGoogleAnalytics from '../hooks/useGoogleAnalytics.js';
import React, { Suspense, lazy } from 'react';

const CopyIcon = lazy(() => import('../components/icons/CopyIcon'));
const ChevronDownIcon = lazy(() => import('../components/icons/ChevronDownIcon'));
const ChevronUpIcon = lazy(() => import('../components/icons/ChevronUpIcon'));




const EarnPage = () => {
  useGoogleAnalytics()
  const [email, setEmail] = useState('');
  const [user, setUser] = useState(null); // State to hold user data
  const [tasksData, setTasksData] = useState([]); // State to hold tasks completion data
  const [tasks, setTasks] = useState([]); // State to hold tasks available for everyone
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [referralCount, setReferralCount] = useState(0);

  const [code, setCode] = useState('');
  const [referal_value, setReferralCode] = useState('please login');
  const inputRef = useRef(null); // Ref to access input element
  const [isWithdrawOpen, setIsWithdrawOpen] = useState(false);
  
  const [views, setViews] = useState("30th August");

  const handleWithdraw = () => {
    
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    // Remove ordinal suffixes like "th", "st", "nd", "rd" and add the current year
    const formattedDate = views.replace(/(\d+)(st|nd|rd|th)/, '$1') + ` ${currentYear}`;

    const targetDate = new Date(formattedDate);
    if (targetDate > currentDate) {
      alert(`Withdraw will open on ${views}`);
    } else {
      setIsWithdrawOpen(true);
    }
  };
  

  const closeWithdraw = () => {
    setIsWithdrawOpen(false);
  };

  const fetchReferralCount = async (Useremail) => {

    try {
      const response = await fetch('/api/referral-count', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ Useremail })
      });

      if (response.ok) {
        const data = await response.json();
        setReferralCount(data.referral_count);
      } else {
        const errorMessage = await response.text();
      
      }
    } catch (error) {
     
    } 
  };




  useEffect(() => {
    const fetchDate = async () => {
      try {
        const response = await fetch('https://dailycoinmarket.com/api/date');
        const data = await response.json();
        
        setViews(data.date);
      } catch (error) {
        console.error('Error fetching views:', error);
      }
    };
    fetchDate();
  }, []);
  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      setUser(JSON.parse(storedUserData));
      fetchTasks();
      fetchUserTasks(JSON.parse(storedUserData).email); // Fetch user tasks if user is logged in
      
      fetchReferralCode(JSON.parse(storedUserData).email);
    }
    fetchTasks(); // Fetch tasks available for everyone
  }, []);


  const subscribeUser = async (email, category = 'simple') => {
    console.log('Subscribe');
    try {
      const subscribeRes = await fetch('https://dailycoinmarket.com/api/subscribe2', {
        method: 'POST',
        body: JSON.stringify({
          email,
          category,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log('Subscribe2');

  
      if (!subscribeRes.ok) {
        throw new Error('Subscription failed');
      }
  
      console.log('Subscribe3');
      const subscribeData = await subscribeRes.json();
      console.log('Subscribe Data:', subscribeData); // Log subscription response
      return subscribeData;
  
    } catch (error) {
      console.log('Error during subscription:', error);
      toast.error('Subscription failed');
      throw error;
    }
  };
  

  const handleLoginSuccess = async (response) => {
    try {
      const res = await fetch('https://dailycoinmarket.com/api/google-login', {
        method: 'POST',
        body: JSON.stringify({
          token: response.credential,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!res.ok) {
        throw new Error('Google login failed');
      }
  
      const userData = await res.json();
      console.log('User Data:', userData); // Log user data response
      const { email, username } = userData;
  
      localStorage.setItem('userData', JSON.stringify({ email, username }));
      setUser({ email, username });
  
      // Subscribe user to default category 'simple' if not already subscribed
      await subscribeUser(email);
      fetchUserTasks(email);
      fetchReferralCode(email);
       // Fetch user tasks after login
      fetchReferralCount(email);
  
    } catch (error) {
      console.log('Error during Google login:', error);
      toast.error('Google login failed');
    }
  };
  
  

  const fetchReferralCode = async (Useremail) => {
    try {
      const response = await fetch(`https://dailycoinmarket.com/api/referral-code?email=${Useremail}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch referral code');
      }
  
      const data = await response.json();
      setReferralCode(data.referral_code);
      console.log('Referral code:', data); // Log the fetched referral code
    } catch (error) {
      console.error('Error fetching referral code:', error);
    }
  };
  
  
  

  const handleLogout = () => {
    localStorage.removeItem('userData');
    setUser(null);
    setTasks([]);
    setTasksData([]);
    setReferralCode('please login');
    setReferralCount(0);
    toast.info('Logged out successfully.');
  };


  


 


  const handleGoogleFailure = (response) => {
    console.error('Google Sign In failed', response);
  };

  const handleChange = (e) => {
    setCode(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://dailycoinmarket.com/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, category: 'simple' }),
      });

      if (response.ok) {
        setEmail('');
        toast.success('Subscription successful! 🎉');
      } else {
        const errorData = await response.json();
        const errorMessage = errorData.error || 'Subscription failed';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error during subscription');
    } finally {
    }
  };

  const fetchUserTasks = async (userEmail) => {
    try {
      const response = await fetch(`https://dailycoinmarket.com/api/user-tasks?email=${userEmail}`);
      if (!response.ok) {
        throw new Error('Failed to fetch user tasks');
      }
      const data = await response.json();

      const response2 = await fetch('https://dailycoinmarket.com/api/tasks');
      if (!response.ok) {
        throw new Error('Failed to fetch tasks');
      }

      const data2 = await response2.json();
      
      setTasksData(data);
      updateTasksWithCompletion(data,data2); // Update tasks with completion data
    } catch (error) {
      console.error('Error fetching user tasks:', error);
    }
  };

  const updateTasksWithCompletion = (tasksData,task1) => {
    // Map through tasks and update completed status from tasksData
    console.log("tasksData",tasksData);
    console.log("tasks", task1)
    const updatedTasks = task1.map(task => ({
      ...task,
      completed: tasksData.find(data => data.task_id === task.id)?.completed 
    }));
    setTasks(updatedTasks);
    console.log("updatedtask",updatedTasks);
  };
  
  

  const fetchTasks = async () => {
    try {
      const response = await fetch('https://dailycoinmarket.com/api/tasks');
      if (!response.ok) {
        throw new Error('Failed to fetch tasks');
      }
  
      const data = await response.json();
      
      // Check if tasks state already has data
      if (tasks.length === 0) {
        setTasks(data); // Set initial data if tasks state is empty
      } else {
        
        
      }
      
      setLoading(false); // Update loading state after fetching tasks
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };
  

  const handleTaskCompletion = async (taskId, link) => {
    
    try {
      const response = await fetch(`https://dailycoinmarket.com/api/tasks/${taskId}/complete`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: user.email }), // Pass the user's email to the backend
      });

      const data = await response.json();
  
      console.log("response maesag",data);
      if (!response.ok) {
        throw new Error('Task completion failed');
      }

  
      // Update tasks data immediately
      const updatedTasks = tasks.map((task) =>
        task.id === taskId ? { ...task, completed: true } : task
      );
      console.log("Dsad");
      setTasks(updatedTasks);
      toast.success('Task will be completed successfully after 30 mins. Make sure you complete it!');
      console.log(link);
      // Redirect to the task's link
      window.open(link, '_blank');
    } catch (error) {
      console.error('Error completing task:', error);
      toast.error('Failed to complete task. Sign in required');
      window.open(link, '_blank');
    }
  };


  const checkReferralCode = async (taskId, link) => {
    
    try {
      const response = await fetch(`https://dailycoinmarket.com/api/referral_task/${taskId}/complete`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: user.email }), // Pass the user's email to the backend
      });

      
      const data = await response.json();
  
      console.log("response message", data);

      if (!response.ok) {
        throw new Error('Task completion failed');
      }

  
      // Update tasks data immediately
      const updatedTasks = tasks.map((task) =>
        task.id === taskId ? { ...task, completed: true } : task
      );
      console.log("Dsad");
      setTasks(updatedTasks);
      toast.success('Task is completed successfully!');
      console.log(link);
    } catch (error) {
      console.error('Error completing task:', error);
      toast.error('Referrals are not enough');
    }
  };
  const handleCopyClick = async () => {
    try {
      if (inputRef.current) {
        await navigator.clipboard.writeText(inputRef.current.value); // Copy text to clipboard
        toast.success('Copied to clipboard!');
      }
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      toast.error('Failed to copy to clipboard');
    }
  };
  
  const CodeCheck = async (taskId, link) => {
    console.log('Checking');
    try {
      const apiUrl = `https://dailycoinmarket.com${link}`;
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          taskId: taskId,
          code: code,
          email: user.email 
        }),
      });
  
      // Convert response to JSON
      const responseData = await response.json();
      console.log(responseData); // Log the JSON data if needed
    
      if (!response.ok) {
        let errorMessage = 'Failed to complete task';
        if (response.status === 404) {
          errorMessage = 'Referral code not found';
        } else if (response.status === 500) {
          errorMessage = 'Internal server error';
        } else {
          // Handle other unexpected status codes
          errorMessage = `Unexpected error: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }
    
      toast.success('Task is completed!');
      console.log(link);
    } catch (error) {
      console.error('Error completing task:', error);
      if (error.message === 'Internal server error') {
        toast.error('Server error occurred. Please try again later.');
      } else {
        toast.error('Wrong Code or Login Required');
      }
    }
  };
  

  

  const shareTask = async (taskId, link) => {
   
    window.open(`whatsapp://send?text=🎉%20Join%20the%20DailyCoinMarket%20Earn%20Program%202024%20and%20get%20exciting%20benefits%20at%20https%3A%2F%2Fdailycoinmarket.com%2Fearn_program_2024%21%20Use%20my%20exclusive%20referral%20code%20${referal_value}%20to%20earn%20an%20additional%20$1%20on%20joining%21%20Don't%20miss%20out%20on%20this%20great%20opportunity%20to%20boost%20your%20earnings%20🚀
`, '_blank');
  };
  


  const calculateEarnings = () => {
    let earnings = 0;
  
    tasksData.forEach((task) => {
      if (task.completed) {
        console.log(parseFloat(task.earnings));
        earnings += parseFloat(task.earnings); // Convert earnings to a number before adding
      }
    });
    return earnings;
  };
  

  const metaDescription = "Subscribe to DailyCoinMarket's Earn Program and participate in our giveaway!";
  const tagsArray = ["DailyCoinMarket", "Earn Program", "cryptocurrency", "giveaway", "subscription"];
  const shareUrl = 'https://dailycoinmarket.com/earn_program_2024';

  const toggleShowMoreTasks = () => {
    setShowMoreTasks(!showMoreTasks);
  };
  const [showMoreTasks, setShowMoreTasks] = useState(false);

  const visibleTasks = showMoreTasks ? tasks : tasks.slice(0, 8);

  return (
    <>
      <Head>
      <title>Earn Cryptocurrency Rewards on DailyCoinMarket | Referral Program & Tasks</title>

      <meta name="description" content="Discover how to earn cryptocurrency rewards on DailyCoinMarket by participating in our referral program and completing various tasks. Start earning rewards today and explore new opportunities in the crypto world." />

      <meta name="keywords" content="dailycoinmarket, DailyCoinMarket, Daily Coin Market, coinmarketcap, earn cryptocurrency rewards, crypto rewards program, referral program cryptocurrency, complete tasks earn crypto, DailyCoinMarket rewards, crypto reward opportunities, cryptocurrency tasks and rewards" />

        
        <link rel="canonical" href={shareUrl} />
        <meta property="og:title" content="Earn Cryptocurrency Rewards on DailyCoinMarket" />
<meta property="og:description" content="Join DailyCoinMarket to earn rewards through our referral program and task completion. Sign in with Google to start earning cryptocurrency rewards and track your progress easily." />
<meta property="og:image" content="https://dailycoinmarket.com/upload/default-image.jpg" /> 
<meta property="og:url" content={shareUrl} />
<meta property="og:type" content="website" />
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:title" content="Earn Cryptocurrency Rewards on DailyCoinMarket" />
<meta name="twitter:description" content="Join DailyCoinMarket to earn rewards through our referral program and task completion. Sign in with Google to start earning cryptocurrency rewards and track your progress easily." />
<meta name="twitter:image" content="https://dailycoinmarket.com/upload/default-image.jpg" />


      </Head>


      <div className={styles.launchPage}>
        <Navbar />
        <div className={styles.rewardStrip}>
          All rewards from the marketing budget will increase from $1,000 to $100,000 with the launch of our new coin when the marketing budget increases.
        </div>
        
        <h1>DailyCoinMarket Earn Program 2024</h1>
        <div className={styles.content}>
          
          <div className={styles.leftSection}>
          <Image src={squirrelImage} alt={"Squirrel"} className={styles.squirrelImage} width={600}  height={400}   />
          </div>
          <div className={styles.rightSection}>
            <h2>Welcome to DailyCoinMarket! 🌟</h2>
            <p>We have launched <strong>the Earn Program</strong>! 🚀</p>
            <p>Subscribe now to participate in our giveaway of up to <strong>$1,000</strong>! 💰</p>
            <p>Complete exciting tasks and be the first to win! 🏆</p>
            <p>Don't miss out on this chance! Subscribe now and stay updated! 📬</p>
            <p><strong className={styles.redText}>Your $ will be transferred to you in live stream after {views}.💰</strong></p>

            <form onSubmit={handleSubmit} className={styles.subscriptionForm}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className={styles.emailInput}
              />
              <br />
              <button type="submit" className={styles.subscribeButton}>Subscribe Now 🔒</button>
            </form>

            <p>Also, subscribe to our <a href="https://www.youtube.com/@DailyCoinMarket" target="_blank" rel="noopener noreferrer" className={styles.youtubeLink}>YouTube channel</a> for updates about the program. 📺</p>
          </div>
        </div>
        <ViewCount />

        <div className={styles.tasksSection}>
          {!user && (
            <div className={styles.googleLoginSection}>
              <GoogleOAuthProvider clientId="10987517040-vhurkduo4aqq58j52d6fvei5rqj5vvq8.apps.googleusercontent.com">
                <GoogleLogin
                  onSuccess={handleLoginSuccess}
                  onFailure={handleGoogleFailure}
                  buttonText="Login with Google"
                />
              </GoogleOAuthProvider>
            </div>
          )}

          <h3>Tasks</h3>
          <p className={styles.warning}>
            Make sure your friend adds your referral code in 1st task / Some Tasks Confirmed after 20-30 mins so make sure you complete it.
          </p>
          <p className={styles.warning}>
            Make sure to validate tasks. Rewards will be given in <strong>live video sessions</strong>, incase of invalidity reward will be <strong>cancelled.</strong><br></br>
            Referral task are most pereferred, user who will make first <strong>200,500 and 1000</strong> join will get rewards upto <strong>2000$</strong>
          </p>
          <Withdraw isOpen={isWithdrawOpen} onRequestClose={closeWithdraw} />

          {loading ? (
  <p>Loading tasks...</p>
) : (
  <>
    <table className={styles.taskTable}>
      <thead>
        <tr>
          <th>Task</th>
          <th>Price</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {visibleTasks
          .sort((a, b) => a.completed - b.completed)
          .map((task) => (
            <tr key={task.id}>
              <td>{task.text}</td>
              <td>{task.price}$</td>
              <td style={{ display: 'flex', alignItems: 'center' }}>
                {!task.completed ? (
                  <>
                    {Boolean(task.field) && (
                      <input
                        type="text"
                        placeholder="Enter Code"
                        className={styles.taskInput}
                        style={{ width: '100px', flexShrink: 0 }}
                        onChange={handleChange}
                      />
                    )}
                    {Boolean(task.field) && (
                      <button
                        className={styles.taskButton}
                        onClick={() => CodeCheck(task.id, task.link)}
                      >
                        Complete
                      </button>
                    )}
                    {!task.is_referral && !task.field && (
                      <button
                        className={styles.taskButton}
                        onClick={() => handleTaskCompletion(task.id, task.link)}
                      >
                        Complete
                      </button>
                    )}
                    {Boolean(task.is_referral) && (
                      <div className={styles.referralTopRow}>
                        <input
                          type="text"
                          placeholder="Enter Code"
                          className={styles.taskInput}
                          style={{ width: '100px', flexShrink: 0 }}
                          value={referal_value}
                          ref={inputRef}
                          disabled
                        />
                        <button onClick={handleCopyClick} className={styles.copyButton}>
                          <CopyIcon />
                        </button>
                        <button
                          className={styles.taskButton1}
                          onClick={() => checkReferralCode(task.id, task.link)}
                        >
                          Check
                        </button>
                        <button
                          className={styles.taskButton1}
                          onClick={() => shareTask(task.id, task.link)}
                        >
                          Share
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <span className={styles.completedText}>Completed</span>
                )}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
    {tasks.length > 7 && (
  <button onClick={toggleShowMoreTasks} className={styles.showMoreButton}>
    {showMoreTasks ? 'Show Less' : 'Show More'}
    <Suspense fallback={<div>Loading...</div>}>
      {showMoreTasks ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Suspense>
  </button>
)}

  </>
)}

          {user && (
            <>
              <div className={styles.userInfo}>
                <h3>Welcome, {user.username}!</h3>
                <p>Email: {user.email}</p>
                <p>Earnings: {calculateEarnings()} $</p>
                <p>Referrals: {referralCount}</p>
                <div className={styles.buttonContainer}>
                  <button onClick={handleLogout} className={styles.logoutButton}>Logout</button>
                  <button onClick={handleWithdraw} className={styles.withdrawButton}>
                    <i className="fas fa-wallet"></i> Withdraw
                  </button>
                </div>
              </div>

              <div className={styles.userTasks}>
                <h3>Your Tasks</h3>
                <ul>
                  {tasksData.map((task) => (
                    <li key={task.id} className={task.completed ? styles.completed : styles.pending}>
                      <span>{task.task_description}</span> ${task.earnings} - {task.completed ? 'Completed' : 'Pending'}
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}

          <div className={styles.rewardBox}>
            <p>Rewards will be available after the launch day of claim on {views}. If we hit 100k views 🎉</p>
            <p>Carefully Subscribe to save your chance to get your share of $1000-100k with our marketing budget!</p>
          </div>
        </div>

        <Footer />
      </div>
      <ToastContainer />
    </>
  );
};

export default EarnPage;